import React, { lazy, Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "./components/ContentRoute/ContentRoute";
import { LayoutSplashScreen } from "./context/LayoutContext";
import RootLayout from "./hoc/RootLayout";
import Patient from "./modules/Patients/pages";

// CC-71241: Maintenance Mode
import maintenanceImg from "../assets/images/maintenance.jpg";

const ProviderNotePage = lazy(() =>
  import("./modules/ProviderNote")
);


// CC-71241: Maintenance Mode
class ProviderNoteErrorBoundary extends React.Component {
  state = { hasError: !!window.__APP_MAINTENANCE__ };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidMount() {
    if (window.__APP_MAINTENANCE__) {
      this.setState({ hasError: true });
    }
    this._onMaintenance = () => this.setState({ hasError: true });
    window.addEventListener("app:maintenance", this._onMaintenance);
  }

  componentWillUnmount() {
    window.removeEventListener("app:maintenance", this._onMaintenance);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen w-full">
          <img src={maintenanceImg} alt="Maintenance" className="w-full h-full object-cover" />
        </div>
      );
    }
    return this.props.children;
  }
}

export default function BasePage({ noteId }) {

  return (
    <ProviderNoteErrorBoundary>
      <RootLayout>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <ContentRoute exact path="/" render={() => (
              <Redirect to={`/provider-note/${noteId}`} />)} />
            <ContentRoute exact path="/provider-note/:id" component={ProviderNotePage} />
            <ContentRoute exact path="/patient" component={Patient} />
          </Switch>
        </Suspense>
      </RootLayout>
    </ProviderNoteErrorBoundary>
  );
}
